import React from 'react';
import {Images} from '../../assets';
import './styles.scss';

type Props = {
  containerCls?: string;
};

export const Loader: React.FC<Props> = ({containerCls = ''}) => {
  return (
    <div className={`loader ${containerCls}`}>
      <img src={Images.LOADER} alt="loader" className="loaderImg" />
    </div>
  );
};
